import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a2f33898"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "desc" }
const _hoisted_5 = { class: "price" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "元/年", -1))
const _hoisted_7 = { class: "btn" }
const _hoisted_8 = { class: "scroll-box" }
const _hoisted_9 = { class: "dialog-footer" }

import { ref, watch, computed } from 'vue'
import Text from '@/components/text'
import { queryTenantPackageList, tenantPackageOrder } from '@/api'
import { CODE_ENUM } from '@/common'
import { ElMessage } from 'element-plus'
import { chunk } from 'lodash'


export default /*#__PURE__*/_defineComponent({
  __name: 'package-check',
  props: ['visible', 'data'],
  emits: ['update:visible', 'success'],
  setup(__props, { emit: __emit }) {

const $emit = __emit
const props = __props

watch(
  () => props.visible,
  () => {
    if (props.visible) {
      queryList()
    }
  }
)

const getButtonLabel = (isFreePackage: boolean, isOpen: boolean) => {
  return isFreePackage ? '免费' : isOpen ? '续费' : '开通'
}

const loading = ref(false)
const packageList: any = ref([])
const queryList = async () => {
  loading.value = true
  const res: any = await queryTenantPackageList({
    topOrgId: props.data.orgId,
    curPage: 1,
    pageSize: 10,
  }).finally(() => {
    loading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    // 拆分为固定长度为2的数组
    packageList.value = chunk(res.data?.records || [], 2)
  }
}

const toCheckPackage = async (index: number, packageId: any) => {
  packageList.value[index].loading = true
  const res: any = await tenantPackageOrder({
    topOrgId: props.data.orgId,
    packageId,
  }).finally(() => {
    packageList.value[index].loading = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    ElMessage.success(res?.msg)
    $emit('success')
    cancel()
  }
}

const cancel = () => {
  $emit('update:visible', false)
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": props.visible,
    title: "套餐管理",
    width: "800px",
    "before-close": cancel
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_9, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: cancel
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 关闭 ")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_carousel, {
          "indicator-position": "outside",
          autoplay: false,
          loop: false,
          height: 568,
          arrow: "always"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(packageList.value, (item, i) => {
              return (_openBlock(), _createBlock(_component_el_carousel_item, { key: item }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(packageList.value[i], (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "package",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("p", _hoisted_3, _toDisplayString(item.packageName), 1),
                        _createElementVNode("div", _hoisted_4, _toDisplayString(item.packageDescription), 1),
                        _createElementVNode("p", _hoisted_5, [
                          _createElementVNode("span", null, _toDisplayString(item.price), 1),
                          _hoisted_6
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                          onClick: ($event: any) => (toCheckPackage(index, item.packageId)),
                          type: "primary",
                          size: "large",
                          disabled: item.isFreePackage || !item.isAbleOperateOpen
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(getButtonLabel(item.isFreePackage, item.isOpen)), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick", "disabled"])), [
                          [_directive_loading, item.loading]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.resourceInfos, (v, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "item",
                            key: i
                          }, [
                            _createVNode(_unref(Text), {
                              class: "resource",
                              content: v.resourceName
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(v.resourceName), 1)
                              ]),
                              _: 2
                            }, 1032, ["content"]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["icon", v.isChoose ? 'checked' : 'uncheck'])
                            }, null, 2)
                          ]))
                        }), 128))
                      ])
                    ]))
                  }), 128))
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ])), [
        [_directive_loading, loading.value]
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})